import { render, staticRenderFns } from "./DIsputeResolutionDetails.vue?vue&type=template&id=41dc1bfd&scoped=true&"
import script from "./DIsputeResolutionDetails.vue?vue&type=script&lang=js&"
export * from "./DIsputeResolutionDetails.vue?vue&type=script&lang=js&"
import style0 from "./DIsputeResolutionDetails.vue?vue&type=style&index=0&id=41dc1bfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dc1bfd",
  null
  
)

export default component.exports